import { EHttpMethods } from "../../../../enums";
import {
  AUTH_BASE_URL,
  GET_USER_STATS,
  GET_CONTRACT_STATS,
  CONTRACT_BASE_URL,
} from "../../../constants";
import { ApiServiceManager, fetchRequest } from "../../apiServiceManager";
import { getToken } from "../../../context/authContext";
import {
  IStatisticsContractResponse,
  IStatisticsUsersResponse,
} from "./models";

const defaultProvide = async () => await getToken();

export const getContractStats = (
  userId?: string | number,
  organizationCode?: string
): Promise<IStatisticsContractResponse> => {
  const urlContract = `${CONTRACT_BASE_URL}${GET_CONTRACT_STATS}`;
  const organizationSearchParam = organizationCode
    ? `${userId ? "&" : "?"}organizationCode=${organizationCode}`
    : "";
  const url = userId
    ? `${urlContract}?userId=${userId}${organizationSearchParam}`
    : `${urlContract}${organizationSearchParam}`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.GET,
    defaultProvide
  );
  return fetchRequest(descriptor);
};

export const getUserStats = (
  organizationCode?: string
): Promise<IStatisticsUsersResponse> => {
  const url = `${AUTH_BASE_URL}/${GET_USER_STATS}${
    organizationCode ? `?organizationCode=${organizationCode}` : ""
  }`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.GET,
    defaultProvide
  );
  return fetchRequest(descriptor);
};
